/**
 * Application main entry point.
 */
import "./config";

import App from "./App";
import { boot } from "./bootstrap";
import { triggerLoadPhase } from "./vendor";

triggerLoadPhase("bootstrap");

boot(App);
